import React from 'react';
import { Card, CardContent } from '@/components/ui/card';
import { TradingViewChart } from '../TradingViewChart';

interface SPYChartProps {
  height?: string | number;
}

export const SPYChart = ({ height = "500px" }: SPYChartProps) => {
  return (
    <Card className="overflow-hidden rounded-[4px]">
      <CardContent className="p-0" style={{ height }}>
        <TradingViewChart 
          symbol="SPY" 
          height="100%"
          width="100%"
        />
      </CardContent>
    </Card>
  );
};
